import React, { Component } from 'react';
import { connect } from 'react-redux';
import makeForm from '../makeForm';
import Form from '../../Common/Form';
import ContinueButton from '../ContinueButton';
import RadioGroup from '../../Common/RadioGroup';
import FormGroup from '../../Common/FormGroup';
import CrossMsg from '../CrossMsg';
import InputCurrency from '../../Common/InputCurrency';
import Input from '../../Common/Input';
import TransparentSndButton from '../../Common/TransparentSndButton';
import { upfrontCleaveOptions, TOP_LEVEL_PREFIX } from '../../../../config';
import { choices } from '../../../../choices';
import { formatMoney, abtest } from '../../../../utils';
import 'rc-tooltip/assets/bootstrap.css';
import Modal from '../../Common/Modal';
import s from '../ContinueButton.scss';
import sc from '../ChatsForm.scss';


const HDForm = ({
    values,
    handleChange,
    handleCleaveChange,
    onSubmit,
    errors,
    is_staff,
    exchange,
    closeModal,
    carModal,
    carModal2,
    setHome,
    setAmount,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            {//Modal 1, para la primer parte del flow
            }
            <Modal showModal={carModal} closeModal={closeModal}>
                <div className={s.modalContainer}>
                    <h3>Actualmente sólo ofrecemos créditos con garantía prendaria o hipotecaria</h3>
                    <label>Si no sos titular de una propiedad te brindamos las siguientes opciones:</label>
                    <div style={{textAlign:'center'}}>
                    <TransparentSndButton style={{borderRadius: "28px"}} type='button' onClick={()=>window.location = 'http://autos.agilis.com.ar'}>Usar mi auto como garantía </TransparentSndButton>
                    <TransparentSndButton style={{borderRadius: "28px"}} type='button' onClick={setHome}>Usar otro inmueble como garantía </TransparentSndButton>
                    </div>
                </div>
            </Modal>
            {//Modal 2, para cuando el monto no es adecuado
            }
            <Modal showModal={carModal2} closeModal={closeModal}>
                <div className={s.modalContainer}>
                    <h3>Solo otorgamos préstamos mayores a USD 15.000 con garantía inmobiliaria.</h3>
                    <label>Como ingresaste {values.requested_currency} {formatMoney(values.requested_value)} te brindamos las siguientes opciones:</label>
                    <div style={{textAlign:'center'}}>
                    <TransparentSndButton style={{borderRadius: "28px"}} type='button' className={s.modalButton} onClick={()=>window.location = 'http://autos.agilis.com.ar'}>Usar mi auto como garantía</TransparentSndButton>
                    <TransparentSndButton style={{borderRadius: "28px"}} type='button' className={s.modalButton} onClick={setAmount}>Solicitar un préstamo de $ 250.000</TransparentSndButton>
                    </div>
                </div>
            </Modal>
            <FormGroup label={`¿Cuánto dinero necesitás?`}>
                <InputCurrency
                    cleaveOptions={upfrontCleaveOptions}
                    placeholder="Ej 50.000"
                    currency='USD'
                    value={values.requested_value || ''}
                    name="requested"
                    onValueChange={handleCleaveChange}
                    onCurrencyChange={handleChange}
                    exchange={exchange}
                    errors={errors.requested_value}
                    addOn="USD"
                />
                {Object.keys(errors).length ? null : <p className={sc.helpTextApp}>Monto máximo: USD 75.000</p>}
            </FormGroup>
                <div>
                    <RadioGroup
                        label="¿Para qué lo vas a usar?"
                        name="destination"
                        errors={errors.destination}
                        onChange={handleChange}
                        selected={values.destination}
                        showDescription={true}
                    >
                        {choices.apptype.HD.map(({ text, value, description, hidden }) => [
                            <div key={value} className={s.radioButton}>
                                {text}
                            </div>,
                            value,
                            description,
                            hidden
                        ])}
                    </RadioGroup>
                    <RadioGroup
                        label="¿Tenés una propiedad para utilizar como garantía?"
                        name="with_collateral"
                        errors={errors.with_collateral}
                        onChange={handleChange}
                        selected={values.with_collateral}
                        flexButton="true"
                    >
                        {[
                            ['Si', true],
                            ['No', false],
                        ]}
                    </RadioGroup>
                    {is_staff && values.destination === 'CD' &&
                        <RadioGroup
                            label="Tipo de deuda"
                            name="reason"
                            errors={errors.reason}
                            onChange={handleChange}
                            selected={values.reason}
                        >
                            {choices.reasons.map(({ text, value }) => [text, value])}
                        </RadioGroup>
                    }
                    {is_staff && (values.destination === 'OT' || values.reason === 'OT') &&
                        <FormGroup
                            label="Comentarios"
                            errors={errors.comments}
                        >
                            <Input
                                name="comments"
                                onChange={handleChange}
                                value={values.comments}
                            />
                        </FormGroup>
                    }
                    {values.with_collateral === false &&
                       <div>
                            <CrossMsg/>
                       </div>
                    }
                    {errors.requested_value && ((values.requested_currency === 'USD' ? values.requested_value < 250000 * exchange.ARS.USD : values.requested_value < 250000) ? null :
                        <ContinueButton sticky={true} autoFocus={false} sticky={true}/>)
                    }
                    {(values.with_collateral === true) ? !!errors.requested_value || <ContinueButton autoFocus={true} sticky={true} disabled={(values.requested_value && values.destination && values.with_collateral) ? false : true}/> : null}
                </div>

        </Form>
    );
}
const CEForm = ({
    values,
    handleChange,
    handleCleaveChange,
    onSubmit,
    errors,
    is_staff,
    exchange,
    app_type,
    abtestData
}) => (
        <Form onSubmit={onSubmit}>
            <FormGroup label={`¿Cuánto dinero necesitás?`}>
                  <InputCurrency
                    cleaveOptions={upfrontCleaveOptions}
                    addOn="$"
                    placeholder="Ej 50.000"
                    currency='ARS'
                    value={values.requested_value || ''}
                    name="requested"
                    onValueChange={handleCleaveChange}
                    onCurrencyChange={handleChange}
                    exchange={exchange}
                    errors={errors.requested_value}
                    app_type={app_type}
                />
                {Object.keys(errors).length ? null : <p className={sc.helpTextApp}>Monto máximo: $ 350.000</p>}
            </FormGroup>
            <div>
                <RadioGroup
                    label="¿Para qué lo vas a usar?"
                    name="destination"
                    errors={errors.destination}
                    onChange={handleChange}
                    selected={values.destination}
                >
                    {choices.apptype.CE.map(({ text, value, description, hidden }) => [
                        <div key={value}>
                            {text}
                        </div>,
                        value,
                        description,
                        hidden
                    ])}
                </RadioGroup>
                <a href={`/prendarios`} className={sc.linkPrendarios}>
                    <TransparentSndButton className={sc.carButton}style={{color: '#2377DB', width: '100%', borderColor: '#2377DB', fontFamily: 'MuseoSans-100', margin: '0px'}} type='button'>Comprar un vehículo</TransparentSndButton>
                </a>
                
                {is_staff && values.destination === 'CD' &&
                    <RadioGroup
                        label="Tipo de deuda"
                        name="reason"
                        errors={errors.reason}
                        onChange={handleChange}
                        selected={values.reason}
                    >
                        {choices.reasons.map(({ text, value }) => [text, value])}
                    </RadioGroup>
                }
                <ContinueButton autoFocus={false} sticky={true} disabled={values.destination && values.requested_value ? false : true}/>
            </div>
        </Form>
    );



class ApplicationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            idleModal: false,
        };
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
    }

    _onIdle(e){
        this.openIdleModal();
    }

    openIdleModal = (e) => {
        this.setState({
            idleModal: true
        });
    }

    render() {
        const { isAppForm } = this.props

        return(
            <div className={isAppForm ? sc.isAppForm : sc.formContainer}>
                <h3 className={sc.aplicationTitle}>Ingresá tus datos</h3>
                {this.props.values.app_type === 'CE' ? <CEForm {...this.props} /> : <HDForm {...this.props} />}
            </div>
    );
}
}
const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff });

export default connect(mapStateToProps)(makeForm(ApplicationForm));
